module.exports = __webpack_public_path__ + "img/p4.ee0c6ff4.png";